import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, SettingDefinitionDto, SettingEntryDto } from '../application-settings/models';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  createOrUpdateSettingEntryByCreateSettingEntry = (createSettingEntry: readonly SettingEntryDto[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/settings',
      body: createSettingEntry,
    },
    { apiName: this.apiName,...config });
  

  getAgentUpdateSettingValues = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, SettingDefinitionDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/settings/agent-update-settings',
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/settings/get-download-token',
    },
    { apiName: this.apiName,...config });
  

  getPSTScanSettings = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, SettingDefinitionDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/settings/pst-settings',
    },
    { apiName: this.apiName,...config });
  

  getSMTPSettingsDefaultValues = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, SettingDefinitionDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: '/api/app/settings',
    },
    { apiName: this.apiName,...config });
}